<template>
  <div id="app">
    <Banner />
    <AboutUs id="about-us" />
    <Products id="products" />
    <Timeline id="timeline" />
    <MediaStory id="report" />
    <Footer id="footer" />
  </div>
</template>

<script>
import Banner from "./components/Banner";
import AboutUs from "./components/AboutUs";
import Products from "./components/Products";
import Timeline from "./components/Timeline";
import MediaStory from "./components/MediaStory";
import Footer from "./components/Footer";

export default {
  name: "app",
  components: {
    Banner,
    AboutUs,
    Products,
    Timeline,
    MediaStory,
    Footer
  }
};
</script>

<style lang="scss">
@import "styles/globals.scss";

#about-us {
  margin-top: 80px;
  margin-bottom: 110px;
}
#products {
  margin-bottom: 80px;
}

#report {
  margin-top: 80px;
}
#footer {
  margin-top: 62px;
}
</style>
